export function autocompleteFilterOption(
  inputValue: string,
  option: { value: string } | undefined
): boolean {
  return !!option?.value.toLowerCase().includes(inputValue.toLowerCase())
}

export function autocompleteFilterOptionWithoutExactMatch(
  inputValue: string,
  option: { value: string } | undefined
): boolean {
  const normalizedInput = inputValue.toLowerCase()
  const normalizedOption = option?.value.toLowerCase()

  return (
    normalizedOption !== undefined &&
    normalizedOption !== normalizedInput &&
    normalizedOption.includes(normalizedInput)
  )
}

export const autocompletePreviewDisabledProps = {
  backfill: false,
  className: 'autocomplete-preview-disabled',
  defaultActiveFirstOption: false,
} as const
